module.exports = __webpack_public_path__ + "static/media/Serving Suggestions_Black Label_gradient.b91df465.png";